export const TELEMEDICINE_ROLES = ['telemedicine_admin', 'telemedicine_doctor'] as const
export const TELEMEDICINE_HOME = '/telemedicine'

const API_PREFIXES = ['/api/telemedicine', '/api/auth']
const PAGE_PREFIXES = [TELEMEDICINE_HOME, '/password', '/login']

function underPrefix(path: string, prefix: string) {
    return path === prefix || path.startsWith(`${prefix}/`)
}

export function isTelemedicineRole(role?: string | null): boolean {
    return !!role && (TELEMEDICINE_ROLES as readonly string[]).includes(role)
}

export function isTelemedicineAdminRole(role?: string | null): boolean {
    return role === 'admin' || role === 'telemedicine_admin'
}

export function isApiPathAllowed(role: string | null | undefined, path: string): boolean {
    if (!isTelemedicineRole(role)) return true
    return API_PREFIXES.some((p) => underPrefix(path, p))
}

export function isPagePathAllowed(role: string | null | undefined, path: string): boolean {
    if (!isTelemedicineRole(role)) return true
    return PAGE_PREFIXES.some((p) => underPrefix(path, p))
}
